import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M11.66 3.58c-.268-.03-.665.045-1.2.58-.503.503-.837 1.321-1.055 2.224-.167.69-.248 1.339-.311 1.84q-.028.223-.053.403a.75.75 0 0 1-.595.63l-2.702.54 4.54 4.54.54-2.702a.75.75 0 0 1 .63-.596q.18-.025.403-.053c.5-.062 1.15-.144 1.84-.31.903-.219 1.72-.552 2.224-1.055.535-.535.61-.932.58-1.2-.035-.31-.23-.65-.58-1L12.66 4.16c-.351-.351-.69-.546-1-.58m.166-1.49c.791.087 1.43.545 1.894 1.01l3.261 3.26c.465.464.922 1.103 1.01 1.895.093.832-.24 1.657-1.01 2.427-.801.801-1.953 1.215-2.932 1.452a17 17 0 0 1-1.86.323l-.709 3.548a.75.75 0 0 1-1.266.383L3.692 9.866a.75.75 0 0 1 .384-1.265l3.547-.71c.063-.493.158-1.172.324-1.86.237-.979.65-2.13 1.452-2.932.77-.769 1.595-1.102 2.427-1.01Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M8.014 12.066a.75.75 0 0 1 0 1.061L3.53 17.611a.75.75 0 1 1-1.06-1.06l4.483-4.484a.75.75 0 0 1 1.061 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPin;
